import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MONTHS } from '@common/dialogs/planning-dialog/modules/planning-diagram/const';

@Component({
  selector: 'com-planning-diagram-header',
  templateUrl: 'planning-diagram-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlanningDiagramHeaderComponent {
  @Input() cellSize: number;
  protected Months = MONTHS;
}
